import { EnterpriseTheme1 } from './enterpriseTheme1/index';

const enterpriseThemeList = [EnterpriseTheme1];

export {
    enterpriseThemeList
}
